import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import Header from '../../layout/Header/Header';
import Footer from '../../layout/Footer/Footer';

import { projectContent1, homeSliderContent_fr, homeSliderContent_en, homeSliderContent_tn } from './Components/SliderContent'
import ClientSlider1 from './Components/ClientSlider';
import HomeSlider from './Components/Homeslider'
import Testimonial from './Components/Testmonial'

import ScrollToTop from '../../Shared/ScrollToTop';
import { Carousel } from '3d-react-carousal';

import Brochure from '../../../assets/brochure devpack.pdf'

import '../../../css/skin/skin-4.min.css';
import './Accueil.css'
import Aos from "aos";

import { useTranslation } from "react-i18next";



const Accueil = ({ lang, SetLang }) => {

    const [t, i18n] = useTranslation('traduction');
    let slides = [
        <div class="dlab-media dlab-img-overlay12 left"> <img src={projectContent1[0].image} alt="0" />
            <div class="dlab-info-has p-a20  ">
                <div class="dlab-post-title">
                    <h5 class="post-title">{t(projectContent1[0].projectName)} </h5>
                </div>
            </div>
        </div>,
        <div class="dlab-media dlab-img-overlay12 left"> <img src={projectContent1[1].image} alt="0" />

            <div class="dlab-info-has p-a20  ">
                <div class="dlab-post-title">
                    <h5 class="post-title">{t(projectContent1[1].projectName)}</h5>
                </div>
            </div>
        </div>,
        <div class="dlab-media dlab-img-overlay12 left"> <img src={projectContent1[2].image} alt="0" />

            <div class="dlab-info-has p-a20  ">
                <div class="dlab-post-title">
                    <h5 class="post-title">{t(projectContent1[2].projectName)}</h5>
                </div>
            </div>
        </div>,
        <div class="dlab-media dlab-img-overlay12 left"> <img src={projectContent1[3].image} alt="0" />

            <div class="dlab-info-has p-a20  ">
                <div class="dlab-post-title">
                    <h5 class="post-title">{t(projectContent1[3].projectName)}</h5>
                </div>
            </div>
        </div>,
        <div class="dlab-media dlab-img-overlay12 left"> <img src={projectContent1[4].image} alt="0" />

            <div class="dlab-info-has p-a20  ">
                <div class="dlab-post-title">
                    <h5 class="post-title">{t(projectContent1[4].projectName)} </h5>
                </div>
            </div>
        </div>,
        <div class="dlab-media dlab-img-overlay12 left"> <img src={projectContent1[5].image} alt="0" />

            <div class="dlab-info-has p-a20  ">
                <div class="dlab-post-title">
                    <h5 class="post-title">{t(projectContent1[5].projectName)} </h5>
                </div>
            </div>
        </div>
    ];
    useEffect(() => {
        Aos.init({
            duration: 1500,
            disable: 'mobile',
            once: true,
            mirror: false
        });
        i18n.changeLanguage(lang);
    }, [i18n, lang]);
    return (
        <>

            <Header lang={lang} SetLang={SetLang} />
            {(() => {
                switch (lang) {
                    case "fr": return <HomeSlider

                        data={homeSliderContent_fr}
                        contentWrapperCls="sliderStyle4"
                        btnCls="site-button"
                        btnText={t('NOS PRODUITS')}
                        btn2Text={t('NOS PRODUITS')}
                        show2Btn
                    />;
                    case "en": return <HomeSlider

                        data={homeSliderContent_en}
                        contentWrapperCls="sliderStyle4"
                        btnCls="site-button"
                        btnText={t('NOS PRODUITS')}
                        btn2Text={t('NOS PRODUITS')}
                        show2Btn
                    />;
                    case "tn": return <HomeSlider

                        data={homeSliderContent_tn}
                        contentWrapperCls="sliderStyle4"
                        btnCls="site-button"
                        btnText={t('NOS PRODUITS')}
                        btn2Text={t('NOS PRODUITS')}
                        show2Btn
                    />;
                    default: return <HomeSlider

                        data={homeSliderContent_fr}
                        contentWrapperCls="sliderStyle4"
                        btnCls="site-button"
                        btnText={t('NOS PRODUITS')}
                        btn2Text={t('NOS PRODUITS')}
                        show2Btn
                    />;
                }
            })()}


            <div class="page-content frame-box"  >
                <div class="content-block area-frame" >
                    <div class="container">


                        <div class="section-full content-inner-1 about-bx">
                            <div class="row">
                                <div class="col-lg-6 m-b30 wow fadeInLeft" data-wow-duration="2s" data-wow-delay="0.3s" data-aos="fade-right">
                                    <div class="about-box">
                                        <Carousel slides={slides} autoplay={true} interval={3000} />
                                    </div>
                                </div>


                                <div class="col-lg-6 m-b30 align-self-center wow fadeInRight" data-aos="fade-left" data-wow-duration="2s" data-wow-delay="0.3s">
                                    <div class="m-b15">
                                        <h2 class="m-b0">{t('À propos de')}<span class="text-primary">DevPack</span></h2>
                                        <div class="dlab-separator bg-primary m-b0"></div>
                                    </div>
                                    <p><strong class="text-primary">DevPack {t('vous offre')} </strong> <h1> {t('Une sélection d’emballages pour vos métiers')} </h1></p>
                                    <Link to="/produits" class="site-button btnhover14"> {t('Nos Produits')} </Link>
                                </div>
                            </div>
                        </div>




                        <div class="section-full content-inner-2 bg-gray wow fadeIn" data-wow-duration="2s" data-wow-delay="0.3s" >
                            <div class="container">
                                <div class="section-head text-black text-center" data-aos="zoom-in-up">
                                    <h2 class="title">{t('Nos Produits')}</h2>
                                    <div class="dlab-separator bg-primary m-b0"></div>
                                </div>
                                <Testimonial lang={lang} SetLang={SetLang} />
                            </div>
                        </div>


                        <div class="section-full content-inner-1 frame-sr-list-area">
                            <div class="section-head text-center" data-aos="zoom-in-up">
                                <h2 class="title">{t('Pourquoi')} DEVPACK ?</h2>
                                <div class="dlab-separator bg-primary m-b0"></div>
                            </div>
                            <div class="row align-items-center">
                                <div class="col-lg-6 wow fadeInUp" data-wow-duration="2s" data-wow-delay="0.3s">
                                    <ul class="service-list">
                                        <li>{t('Peu de matières premières utilisées et un gain de poids maximal.')}</li>
                                        <li>{t('Densité réduite de 1.04 a 0.06/cm3')}</li>
                                        <li>{t('Barquette 100% mono-matériau.')}</li>
                                        <li>{t('Meilleur rapport Qualité / prix.')}</li>
                                    </ul>
                                </div>
                                <div class="col-lg-6 wow fadeInUp" data-wow-duration="2s" data-wow-delay="0.6s">
                                    <ul class="service-list">
                                        <li>{t('Mousse auto-absorbante pas de buvard séparé.')}</li>
                                        <li>{t('Couvercle et films adaptés disponibles')}</li>
                                        <li>{t('Nombreux formats et coloris disponibles.')}</li>
                                        <li>{t('Packaging Solutions, Tout Simplement du frais emballé!')}</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="m-t40 text-center">
                                <a href={Brochure}
                                    class="site-button btnhover14"
                                    target="_blank"
                                    rel="noreferrer">
                                    {t('Télécharger Brochure')}

                                </a>
                            </div>
                        </div>



                        <div class="section-full content-inner wow fadeIn" data-wow-duration="2s" data-wow-delay="0.3s">
                            <div class="section-head text-center" data-aos="zoom-in-up">
                                <h2 class="title"> {t('Nos Références')}</h2>
                                <div class="dlab-separator bg-primary m-b0"></div>
                            </div>
                            <ClientSlider1 />
                        </div>
                    </div>
                </div>
            </div>

            <Footer lang={lang} SetLang={SetLang} />
            <ScrollToTop className="scroltop style2 radius " />
        </>
    )

}
export default Accueil;



